import script from "./ShareholdersTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareholdersTable.vue?vue&type=script&setup=true&lang=ts"

import "./ShareholdersTable.vue?vue&type=style&index=0&id=d6deec92&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6deec92"]])

export default __exports__